import React from "react";
import { FiSettings, FiTrendingUp, FiLayers, FiSmartphone, FiShield, FiZap, FiUsers, FiShoppingCart, FiGlobe, FiCode } from "react-icons/fi";
import {
  LuSettings,
  LuUsers,
  LuSmartphone,
  LuShieldCheck,
  LuPercent,
  LuShield,
  LuBuilding2,
  LuShoppingBag,
  LuClock,
  LuWallet,
  LuCpu,
  LuClipboardList,
  LuPalette,
  LuCode,
  LuBug,
  LuRocket,
} from "react-icons/lu";

// 1. Hero Block Configuration
export const magentoDevelopmentHeroData = {
  backgroundImage: "/images/serviceBanners/magentoBanner.webp",
  whiteImage: "/images/serviceBanners/MagentoBannerW.webp",
  subTitle: "Creating Magento eCommerce Solutions That Drive Growth",
  title: (
    <>
      Scalable <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">Magento Development</span> <br /> Solutions
    </>
  ),
  description:
    "We build high performance Magento ecommerce solutions that are scalable, secure, and optimized to enhance user experience, improve store performance, and drive higher online sales through robust architecture and customization.",
  primaryButton: {
    title: "Start Your Store",
    onClick: () => console.log("Magento Start clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("View Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "High Performance",
      desc: "Optimized Magento solutions for speed and scalability.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Responsive Design",
      desc: "Perfect experience across all devices and screen sizes.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Secure & Reliable",
      desc: "Built with strong security standards and stable architecture.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Clean Code",
      desc: "Maintainable and developer-friendly Magento code structure.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "6%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
  ],
};
// 2. Stats Block
export const magentoStatsData = [
  {
    icon: LuSettings,
    value: "150+",
    label: "Apps Built",
    colorClass: "text-[#00d2ff]",
    bgClass: "bg-[#00d2ff]/10",
    borderClass: "border-[#00d2ff]/20",
    glowClass: "shadow-[0_0_20px_rgba(0,210,255,0.15)]",
  },
  {
    icon: LuUsers,
    value: "90+",
    label: "Happy Clients",
    colorClass: "text-[#a855f7]",
    bgClass: "bg-[#a855f7]/10",
    borderClass: "border-[#a855f7]/20",
    glowClass: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  {
    icon: LuSmartphone,
    value: "50M+",
    label: "Downloads",
    colorClass: "text-[#06b6d4]",
    bgClass: "bg-[#06b6d4]/10",
    borderClass: "border-[#06b6d4]/20",
    glowClass: "shadow-[0_0_20px_rgba(6,182,212,0.15)]",
  },
  {
    icon: LuShieldCheck,
    value: "99.9%",
    label: "Crash-Free Apps",
    colorClass: "text-[#3b82f6]",
    bgClass: "bg-[#3b82f6]/10",
    borderClass: "border-[#3b82f6]/20",
    glowClass: "shadow-[0_0_20px_rgba(59,130,246,0.15)]",
  },
  {
    icon: LuPercent,
    value: "40%",
    label: "Faster Development",
    colorClass: "text-[#d946ef]",
    bgClass: "bg-[#d946ef]/10",
    borderClass: "border-[#d946ef]/20",
    glowClass: "shadow-[0_0_20px_rgba(217,70,239,0.15)]",
  },
  {
    icon: LuShield,
    value: "100%",
    label: "Client Satisfaction",
    colorClass: "text-[#6366f1]",
    bgClass: "bg-[#6366f1]/10",
    borderClass: "border-[#6366f1]/20",
    glowClass: "shadow-[0_0_20px_rgba(99,102,241,0.15)]",
  },
];

// 3. Solutions & Process Block (WhyChooseUs Data)
export const magentoSolutionsAndProcessData = {
  buildSubtitle: "OUR CAPABILITIES",
  buildTitle: "Custom Magento Development Solutions for Every Business Need",
  buildCards: [
    {
      title: "High-Performance Magento Development",
      desc: "Build fast and scalable Magento solutions tailored for business growth.",
      icon: FiShoppingCart,
      colorClass: "text-[#ee672f]",
      bgClass: "bg-[#ee672f]/10",
      borderClass: "border-[#ee672f]/20 hover:border-[#ee672f]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(238,103,47,0.25)]",
    },
    {
      title: "Enterprise Magento Solutions",
      desc: "Develop secure and scalable eCommerce platforms for large businesses.",
      icon: FiGlobe,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "E-Commerce Magento Development",
      desc: "Create feature-rich online stores with smooth shopping experiences.",
      icon: FiCode,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "On-Demand Magento Solutions",
      desc: "Build flexible eCommerce systems with real-time functionality and management.",
      icon: FiShield,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "Secure Magento Development",
      desc: "Develop secure and reliable Magento applications with best practices.",
      icon: FiShield,
      colorClass: "text-[#34d399]",
      bgClass: "bg-[#34d399]/10",
      borderClass: "border-[#34d399]/20 hover:border-[#34d399]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(52,211,153,0.25)]",
    },
    {
      title: "Custom Magento Solutions",
      desc: "Tailored Magento development based on business goals and requirements.",
      icon: FiShoppingCart,
      colorClass: "text-[#f59e0b]",
      bgClass: "bg-[#f59e0b]/10",
      borderClass: "border-[#f59e0b]/20 hover:border-[#f59e0b]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(245,158,11,0.25)]",
    },
  ],
  processSubtitle: "OUR DEVELOPMENT PROCESS",
  processTitle: "Magento Development Process",
  processSteps: [
    {
      step: "01",
      title: "Discovery & Consultation",
      description: "Understand business goals, target audience, and project requirements.",
      icon: LuUsers,
    },
    {
      step: "02",
      title: "Strategy & Planning",
      description: "Define Magento features, architecture, and execution roadmap.",
      icon: LuPalette,
    },
    {
      step: "03",
      title: "UI/UX Design",
      description: "Create intuitive and conversion-focused eCommerce interface designs.",
      icon: LuCode,
    },
    {
      step: "04",
      title: "Development",
      description: "Build scalable and high-performance Magento store with clean architecture.",
      icon: LuBug,
    },
    {
      step: "05",
      title: "Quality Testing",
      description: "Test functionality, performance, and security for smooth user experience.",
      icon: LuPalette,
    },
    {
      step: "06",
      title: "Deployment & Support",
      description: "Launch store and provide continuous updates and technical support.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY CHOOSE OUR MAGENTO DEVELOPMENT SERVICES?",
  benefitsTitle: "Why Businesses Choose Magento Development Solutions",
  benefits: [
    "Cross-platform support",
    "Faster development speed",
    "Modern UI design",
    "Smooth performance optimization",
    "Efficient workflow process",
    "Scalable Magento solutions",
    "Cost-effective development approach",
  ],
  logoImage: "/images/serviceBanners/magentoBanner.webp",
  whiteLogoImage: "/images/serviceBanners/MagentoBannerW.webp",
};
// 4. Portfolio Data
export const magentoPortfolioData = {
  subtitle: "OUR ECOMMERCE WORK",
  title: "Magento Stores Built for Growth",
  buttonText: "View All Projects",
  buttonLink: "#",
  apps: [
    {
      title: "Fashion Hub Global",
      badge: "Retail B2C",
      badgeColor: "bg-[#ee672f]/10 text-[#ee672f] border-[#ee672f]/20",
      desc: "A multi-currency, multi-language Magento storefront handling 50k+ SKU catalog.",
      downloads: "50k+ Products",
      rating: "5.0",
      image: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&w=800&q=80",
    },
  ],
};

// 5. Technologies Data
export const magentoTechnologiesData = {
  techTitle: "MAGENTO TOOL STACK",
  technologies: [
    { name: "Magento 2", icon: "RestAPI" },
    { name: "PHP/MySQL", icon: "SQLite" },
    { name: "ElasticSearch", icon: "Search" },
    { name: "Redis Caching", icon: "Zap" },
    { name: "PWA Studio", icon: "Vite" },
    { name: "GraphQL", icon: "Code" },
  ],
  trustTitle: "TRUSTED BY TOP RETAILERS",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google_logo" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft_logo" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon_logo" },
    { image: "/images/logo/Adobe_Corporate_logo.png", alt: "adobe_logo" },
    { image: "/images/logo/IBM_logo.png", alt: "ibm_logo" },
    { image: "/images/logo/Oracle_logo.png", alt: "oracle_logo" },
  ],
};

// 6. About Overview
export const magentoAboutData = [
  {
    title: "Magento Development Services for High-Performance eCommerce Stores",
    content: (
      <>
        Building a successful online store requires more than attractive product pages. Effective <b className="text-text-primary font-semibold">magento development services</b>{" "}
        help businesses create scalable eCommerce platforms designed for better performance, smoother navigation, and stronger customer experiences. Businesses often face
        challenges with slow websites, poor checkout flows, and limited flexibility that impact sales growth. At{" "}
        <b className="text-text-primary font-semibold">Tycho Technologies</b>, Magento solutions are developed around business requirements, customer expectations, and long-term
        scalability to help brands improve digital commerce performance.
      </>
    ),
  },
  {
    title: "Magento Ecommerce Development for Better Customer Experience",
    content: (
      <>
        A strong online shopping experience plays an important role in customer retention and conversions. Reliable{" "}
        <b className="text-text-primary font-semibold">magento ecommerce development</b> helps businesses improve product management, shopping journeys, and operational efficiency
        without compromising performance. Companies investing in <b className="text-text-primary font-semibold">custom magento store development</b> often achieve stronger
        flexibility because platforms can be tailored to unique business models and customer needs. Tycho Technologies focuses on practical development strategies that support
        performance, usability, and business growth in competitive eCommerce markets.
      </>
    ),
  },
  {
    title: "Adobe Commerce Development Company Focused on Scalable Growth",
    content: (
      <>
        Growing eCommerce businesses require platforms that can adapt to increasing traffic, larger inventories, and evolving customer expectations. A trusted{" "}
        <b className="text-text-primary font-semibold">adobe commerce development company</b> helps businesses create digital storefronts designed for stability and long-term
        expansion. Organizations aiming to strengthen online sales often align platform improvements with{" "}
        <a href="https://tychotechnologies.com/shopify-development-india" className="text-cyan-400 underline hover:text-cyan-300">
          shopify development services
        </a>{" "}
        to compare growth opportunities and create stronger multi-platform commerce strategies.
      </>
    ),
  },
  {
    title: "Why Businesses Choose a Magento Development Company in India",
    content: (
      <>
        The demand for a trusted <b className="text-text-primary font-semibold">magento development company in india</b> continues to grow as businesses seek flexible and scalable
        eCommerce solutions. Companies investing in <b className="text-text-primary font-semibold">ecommerce development services india</b> often prioritize reliability,
        customization, and stronger digital shopping experiences. Businesses working with Tycho Technologies benefit from tailored Magento frameworks designed around measurable
        business objectives. Many organizations also strengthen digital commerce ecosystems through{" "}
        <b className="text-text-primary font-semibold">ecommerce development services</b> to improve long-term scalability and customer engagement.
      </>
    ),
  },
];

// 7. FAQs (Preserved)
export const magentoDevelopmentFaqs = [
  {
    q: "Why should I choose Magento development for my eCommerce store?",
    a: "Magento development helps businesses create scalable, secure, and feature-rich eCommerce stores with advanced customization and robust performance.",
  },
  {
    q: "Why hire Magento developers in India?",
    a: "India provides cost-effective solutions with experienced developers who ensure timely delivery, reliable support, and optimized stores for better sales.",
  },
];
